import { Pipe, PipeTransform } from '@angular/core';
import { UnifiedProject } from '@shared/constants/models.const';

@Pipe({
  name: 'filterByProjStatus',
  standalone: true,
})
// This is special order ! Don`t ask why we can`t do it on BE side
export class FilterProjPipe implements PipeTransform {
  transform(value: UnifiedProject[], projStatus: string): UnifiedProject[] {
    return value.filter(item => item.status === projStatus) || [];
  }
}
